import { render, staticRenderFns } from "./ModalAlterarSenha.vue?vue&type=template&id=dc7eeeb0&scoped=true&"
import script from "./ModalAlterarSenha.vue?vue&type=script&lang=js&"
export * from "./ModalAlterarSenha.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlterarSenha.vue?vue&type=style&index=0&id=dc7eeeb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7eeeb0",
  null
  
)

export default component.exports